import { Grid, Typography, Paper } from '@material-ui/core'
import React from 'react'

import { gregorianToJalaali } from '../../helpers/date'
import { getTranslate, lang } from '../../localization'
import { useStyles } from './styles/RequestInfo.styles'

interface Props {
  email: string
  allocateRange: string
  channel: string
  type: string
  date: string
  allocateNumber: number
  roomType: string
  status: string
  accommodation: string
}

const RequestInfoComponent: React.FC<Props> = ({
  email,
  allocateRange,
  channel,
  type,
  date,
  allocateNumber,
  roomType,
  accommodation,
  status
}) => {
  const classes = useStyles()

  return (
    <Paper className={classes.root} elevation={0}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3} className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Email')}
          </Typography>
          <Typography className={classes.value}>{email}</Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Allocate Range')}
          </Typography>
          <Typography className={classes.value}>{allocateRange}</Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Channel')}
          </Typography>
          <Typography className={classes.value}>{channel}</Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Type')}
          </Typography>
          <Typography className={classes.value}>
            {getTranslate(type)}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Date')}
          </Typography>
          <Typography className={classes.value}>
            {lang === 'fa' ? gregorianToJalaali(date) : date}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Allocate Number')}
          </Typography>
          <Typography className={classes.value}>{allocateNumber}</Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Accommodation / Roomtype')}
          </Typography>
          <Typography className={classes.value}>
            {accommodation + ' / ' + roomType}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.row}>
          <Typography className={classes.label}>
            {getTranslate('Status')}
          </Typography>
          <Typography className={classes.value}>
            {getTranslate(status)}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default RequestInfoComponent
